const anaConsts = require('analytics/constants').default;

const legacyEventNames = {
    banner: {
        click: anaConsts.EVENT_NAMES.PLA_SPONSORED_BANNER_CLICK,
        impression: anaConsts.EVENT_NAMES.PLA_SPONSORED_BANNER_VIEWABLE_IMPR
    },
    pla: {
        click: anaConsts.EVENT_NAMES.PLA_SPONSORED_PRODUCT_CLICK,
        impression: anaConsts.EVENT_NAMES.PLA_SPONSORED_PRODUCT_VIEWABLE_IMPR
    }
};

// To future reference, the following are the components and their respective event types:
// const components = {
//     banner: 'banner',
//     pla: 'pla'
// };

export const mountPLAEventName = ({ page, component, section, type }) => {
    const { RMN_UFE_EVENT, RMN_PAGE_NAMES } = anaConsts;

    // TO-DO: Remove this condition once all pages are migrated to UFE
    const valiPages = [RMN_PAGE_NAMES.search, RMN_PAGE_NAMES.category];

    if (!page || !component || !section || !type) {
        // eslint-disable-next-line no-console
        console.warn(
            'Missing required parameters, the event name will not be generated. Please provide the required parameters: page, component, section, type'
        );

        return legacyEventNames[component][type];
    }

    if (valiPages.includes(page)) {
        const eventName = `${RMN_UFE_EVENT}.${page}.${component}.${section}.${type}`;

        return eventName;
    } else {
        // TO-DO: Remove this once all pages are migrated to UFE
        const eventName = legacyEventNames[component][type];

        return eventName;
    }
};

export const mountEventData = type => {
    const page = digitalData?.page?.pageInfo?.eventPageName?.toLowerCase().includes('category')
        ? anaConsts.RMN_PAGE_NAMES.category
        : anaConsts.RMN_PAGE_NAMES.search;

    return mountPLAEventName({
        page: page,
        type,
        section: 'in_grid',
        component: 'pla'
    });
};
